import React from "react";
import { observer } from "mobx-react";
import { AiSearchPatternViewStore } from "../../store";
import { AiSearchPatternViewForm } from "./AiSearchPatternViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type AiSearchPatternViewProps = {
  aiSearchPatternViewStore: AiSearchPatternViewStore;
};

export const AiSearchPatternView: React.FC<AiSearchPatternViewProps> = observer(
  ({ aiSearchPatternViewStore }) => {
    return (
      <div>
        <AiSearchPatternViewForm
          name={aiSearchPatternViewStore.nameValue}
          description={aiSearchPatternViewStore.descriptionValue}
          pattern={aiSearchPatternViewStore.patternValue}
          pathTypes={aiSearchPatternViewStore.pathTypesValue}
          tools={aiSearchPatternViewStore.toolsValue}
          effectiveness={aiSearchPatternViewStore.effectivenessValue}
          evaluationCount={aiSearchPatternViewStore.evaluationCountValue}
          successCount={aiSearchPatternViewStore.successCountValue}
          sourceEvalIds={aiSearchPatternViewStore.sourceEvalIdsValue}
          proposedBy={aiSearchPatternViewStore.proposedByValue}
          active={aiSearchPatternViewStore.activeValue}
          priority={aiSearchPatternViewStore.priorityValue}
          onPrint={(handlePrint: () => void) =>
            aiSearchPatternViewStore.printAiSearchPattern(handlePrint)
          }
          onCancel={() => aiSearchPatternViewStore.cancelAiSearchPattern()}
          onEdit={
            aiSearchPatternViewStore.isEditEnabled
              ? () => aiSearchPatternViewStore.editAiSearchPattern()
              : undefined
          }
        />
        <ErrorDialog
          open={aiSearchPatternViewStore.errorDialogOpened}
          title={aiSearchPatternViewStore.errorTitle}
          description={aiSearchPatternViewStore.errorDescription}
          onClose={() => aiSearchPatternViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
